import 'zone.js/plugins/zone-error';
import {EnvironmentAdmin} from 'compob2b-libs';

class EnvironmentAdminDev extends EnvironmentAdmin {
  production = true;
  serviceWorkers = true;
  accessRolesCatalog = false;
  serverApi = 'https://a101.compo-soft.ru/api/v1';
  serverPicturesPath = 'https://a101.compo-soft.ru/pictures';
  serverDocumentsPath = 'https://a101.compo-soft.ru/documents';
  serverUrl = 'https://a101.compo-soft.ru';
  impersonate = false;
  enableWorkflowButton = true;
  showDiscountPanel = true;
  useYandexGPT = false;
  damTemplateId = 370;
  damShowCatalogInListing = true;
  compreface = true;
}

export const environment = new EnvironmentAdminDev();
